import React from 'react';
import '../App.css';
import './ClinicalSupervision.css'
import { motion } from 'framer-motion';
import Header from './CSServicesHeader.png';
import IS from './organic.png';
import { Link } from 'react-router-dom';
import DS from './organic (1).png';
import GS from './organic (2).png';

class CSServices extends React.Component {
    render() {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <h1>Supervision Services</h1>
                <p>Clinical supervision is essential for developing confident, ethical, and effective psychotherapists. At Tall Tree Psychotherapy, flexible supervision options are tailored to your learning needs, professional goals, and budget.</p>
                <p>Whether you’re an RP (Qualifying) or an experienced clinician, Tracy is here to support your growth with collaborative, high-quality supervision.</p>
                <br /><br />
                <Link to='clinical-supervision/contact' target="_blank" className="link-button">Book a consultation to get started</Link>
                <div className='twocol'>
                    <img src={IS} className='twoimg' />
                    <p>
                        Individual clinical supervision is offered on an hourly basis, allowing you to choose the frequency and number of sessions based on your experience level, College of Registered Psychotherapists of Ontario requirements, and professional development goals.
                        <br /><br />
                        For more details on supervision hours and requirements, please visit the <Link to="/clinical-supervision/faq">FAQ section</Link>.
                        <br /><br />
                        <Link to="/clinical-supervision/fees">
                            Click here to see our fees
                        </Link>
                    </p>
                </div>
                <div className='division' />
                <div className='twocol'>
                    <img src={DS} className='twoimg' />
                    <p>
                        Dyadic clinical supervision is a cost-effective way to gain supervision hours while learning from the experience of another clinician. Sessions are typically two hours in length, with one hour dedicated to your own client work—while both hours count toward College of Registered Psychotherapists of Ontario supervision requirements.
                        <br /><br />
                        You can join with a colleague or be matched with another Tall Tree Psychotherapy supervisee (based on availability). This format supports skill development, collaboration, and shared learning.
                        <br /><br />
                        For more details, please visit the <Link to="/clinical-supervision/faq">FAQ section</Link>.
                        <br /><br />
                        <Link to="/clinical-supervision/fees">
                            Click here to see our fees
                        </Link>
                    </p>
                </div>
                <div className='division' />
                <div className='twocol'>
                    <img src={GS} className='twoimg' />
                    <p>
                        Group clinical supervision offers a collaborative and cost-effective way to gain supervision hours while learning from an experienced supervisor and a supportive network of peers. Receive feedback on clinical cases, build your skills, and deepen your understanding of psychotherapy practice.
                        <br /><br />
                        Sessions are typically two hours, with dedicated time for your own client work. Group supervision supports both CRPO supervision requirements and ongoing professional development.
                        <br /><br />
                        <Link to="/clinical-supervision/fees">
                            Click here to see our fees
                        </Link>
                    </p>
                </div>
                <br /><br /><br /><br />
                <Link to="/clinical-supervision/contact" className="link-button">
                    Contact Us
                </Link>
                <br /><br /><br /><br />
            </motion.div>
        )
    }
}

export default CSServices;